import commonHelper from '@/app/utility/common.helper.utility';
import invoiceLineDetails from './invoiceLineDetails';
export default {
  name: 'invoiceDetails',
  components: { invoiceLineDetails },
  watch: {
    currentPage: function() {
      this.getInvoiceDetailsData();
    },
    perPage: function() {
      this.currentPage = 1;
      this.getInvoiceDetailsData();
    }
  },
  data() {
    return {
      uploaddocumentModal: false,
      loader: false,
      showAlert: false,
      fileNames: null,
      isSuccess: false,
      responseMsg: null,
      fileName: null,
      perPage: commonHelper.perPageRecord,
      pageOptions: commonHelper.getPageOption(),
      totalRows: null,
      currentPage: 1,
      selectedFilesArr: [],
      invoiceDetailsData: [],
      invoiceDetailsFields: [
        {
          key: 'bill_from_name',
          label: 'Bill From Name',
          class: 'text-center'
        },
        {
          key: 'bill_from_gstin',
          label: 'Bill From GSTN',
          class: 'text-center'
        },
        {
          key: 'bill_to_name',
          label: 'Bill To Name',
          class: 'text-center'
        },

        {
          key: 'bill_to_gstin',
          label: 'Bill To GSTN',
          class: 'text-center'
        },
        {
          key: 'invoice_date',
          label: 'Invoice Date',
          class: 'text-center'
        },
        {
          key: 'invoice_number',
          label: 'Invoice Number',
          class: 'text-center'
        },
        {
          key: 'purchase_order_no',
          label: 'PO Number',
          class: 'text-center'
        },
        {
          key: 'pan_no',
          label: 'PAN Number',
          class: 'text-center'
        },
        {
          key: 'base_amount',
          label: 'Base Amount',
          class: 'text-center'
        },
        {
          key: 'tax_amount',
          label: 'Tax Amount',
          class: 'text-center'
        },

        {
          key: 'total_amount',
          label: 'Total Amount',
          class: 'text-center'
        }
      ],
      invoiceDetailGridData: [],
      invoiceDetailsGridFields: [
        {
          key: 'bill_from_name',
          label: 'Bill From Name',
          class: 'text-center'
        },
        {
          key: 'bill_from_gstin',
          label: 'Bill From GSTN',
          class: 'text-center'
        },
        {
          key: 'bill_to_name',
          label: 'Bill To Name',
          class: 'text-center'
        },

        {
          key: 'bill_to_gstin',
          label: 'Bill To GSTN',
          class: 'text-center'
        },
        {
          key: 'invoice_date',
          label: 'Invoice Date',
          class: 'text-center'
        },
        {
          key: 'invoice_number',
          label: 'Invoice Number',
          class: 'text-center'
        },
        {
          key: 'purchase_order_no',
          label: 'PO Number',
          class: 'text-center'
        },
        {
          key: 'pan_no',
          label: 'PAN Number',
          class: 'text-center'
        },
        {
          key: 'base_amount',
          label: 'Base Amount',
          class: 'text-center'
        },
        {
          key: 'tax_amount',
          label: 'Tax Amount',
          class: 'text-center'
        },

        {
          key: 'total_amount',
          label: 'Total Amount',
          class: 'text-center'
        }
      ],
      showInvoiceDetailsModal: false,
      headerId: null,
      invoiceLineDeatils: []
    };
  },
  mounted() {
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'shared/setActionName') {
        const actionName = state.shared.actionName;
        if (actionName === 'upload') {
          this.uploaddocumentModal = true;
        }
      }
    });
  },
  methods: {
    selectFile() {
      this.selectedFilesArr.push(this.$refs.file.files);
      this.fileNames = this.selectedFilesArr[0][0].name;
      this.saveFileToTempTable(this.$refs.file.files.item(0));
    },
    saveFileToTempTable(fileName) {
      this.invoiceDetailsData = [];
      let formData = new FormData();
      formData.append('file', fileName);
      this.loader = true;
      this.$store
        .dispatch('invoiceDetails/uploadInvoiceDocumnet', formData)
        .then(response => {
          this.loader = false;
          this.showAlert = true;
          if (response.status === 200) {
            this.isSuccess = true;
            this.responseMsg = response.data.message;
            this.invoiceDetailsData.push(response.data.data);
            this.invoiceLineDeatils = response.data.data.invoice_dtl;
            this.postInvoiceDetailsData();
          }
        });
    },

    browseFile() {
      this.$refs.file.click();
    },
    showHideUploadDocument(flag) {
      this.uploaddocumentModal = flag;
      this.invoiceDetailsData = [];
      this.showAlert = false;
      this.fileNames = null;
      this.getInvoiceDetailsData();
    },
    postInvoiceDetailsData() {
      const payload = {
        id: 0,
        invoice_number: this.invoiceDetailsData[0].invoice_number,
        bill_from_gstin: this.invoiceDetailsData[0].bill_from_gstin,
        invoice_date: this.invoiceDetailsData[0].invoice_date,
        pan_no: this.invoiceDetailsData[0].pan_no,
        total_amount: this.invoiceDetailsData[0].total_amount,
        tax_amount: this.invoiceDetailsData[0].tax_amount,
        bill_from_name: this.invoiceDetailsData[0].bill_from_name,
        bill_to_name: this.invoiceDetailsData[0].bill_to_name,
        bill_to_gstin: this.invoiceDetailsData[0].bill_to_gstin,
        base_amount: this.invoiceDetailsData[0].base_amount,
        file_name: this.invoiceDetailsData[0].file_name,
        purchase_order_no: this.invoiceDetailsData[0].purchase_order_no
          ? this.invoiceDetailsData[0].purchase_order_no
          : null,
        invoice_dtl: this.invoiceLineDeatils
      };
      this.loader = true;
      this.$store
        .dispatch('invoiceDetails/postInvoiceDetailsData', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            this.showAlert = true;
            this.isSuccess = true;
            this.responseMsg = response.data.message;
          } else {
            this.showAlert = true;
            this.isSuccess = false;
            this.responseMsg = response.response.data.message;
          }
        });
    },
    getInvoiceDetailsData() {
      const payload = {
        _page: this.currentPage - 1,
        _limit: this.perPage,
        file_name: this.fileName ? this.fileName : null
      };
      this.loader = true;
      this.$store
        .dispatch('invoiceDetails/getInvoiceDetailsData', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            this.$bvToast.toast(response.data.message, {
              title: 'Alert',
              variant: 'success',
              solid: true
            });
            this.invoiceDetailGridData = response.data.data.page;
            this.totalRows = response.data.data.total_elements;
          } else {
            this.$bvToast.toast(response.response.data.message, {
              title: 'Alert',
              variant: 'danger',
              solid: true
            });
          }
        });
    },
    clearFilters() {
      this.fileName = null;
    },
    clearValueSetModal(type) {
      if (type === 'fileName') {
        this.fileName = null;
      }
    },
    rowSelected(item) {
      this.headerId = item.id;
      this.showInvoiceDetailsModal = true;
    },
    showHideInvoiceDetailsModal(flag) {
      this.showInvoiceDetailsModal = flag;
    }
  },
  beforeDestroy() {
    this.unsubscribe();
  }
};
